import React, { useState } from "react";
import "./MonitoringChoose.css";
import img1 from '../monitoringassets/choose1.png';
import img2 from '../monitoringassets/choose2.png';
import img3 from '../monitoringassets/choose3.png';
import img4 from '../monitoringassets/choose4.png';

export default function MonitoringChoose() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      img: img1,
      id: 1,
      title: "Azure DevOps Automated Testing",
      description:
        "Streamline your Azure DevOps infrastructure by automating CI/CD pipelines and running continuous tests right from the start of the software development lifecycle",
    },
    {
      img: img2,
      id: 2,
      title: "AWS Automated Testing Process",
      description:
        "Integrate your AWS DevOps development process with best-in-class automation tools to reduce potential bugs and create robust cloud applications",
    },
    {
      img: img3,
      id: 3,
      title: "Build-Deployment Automation",
      description:
        "Cut down the scope of human intervention so that you can decrease the number of possible errors by thoroughly automating your build and deployment process",
    },
    {
      img: img4,
      id: 4,
      title: "DevOps Workflow Automation",
      description:
        "Embrace DevOps automation best practices and strategies to facilitate an efficient workflow in your business and reduce manual, time-consuming workload",
    },
  ];

  return (
    <div id="monitor-choose" className="outsourcemainclass">
      <div className="top">
        <h2 className="heading">
          Automating DevOps to Build a Synergistic Business Environment
        </h2>
        <p className="subheading">
          Our DevOps engineers automate deployments using workflow and test
          automation to improve efficiency, reliability, and collaboration
          across the DevOps lifecycle.{" "}
        </p>
      </div>
      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <img src={card.img} alt="error" />
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                <img src={card.img} alt="error" />
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
